export enum SelectorWidgetNavigationType {
	SELECTOR_BUTTON = 'SELECTOR_BUTTON',
	SELECTOR_DROPLIST = 'SELECTOR_DROPLIST',
	SELECTOR_SEARCH = 'SELECTOR_SEARCH',
}
